
$(".segura-estoque-destaque figure").on("mouseover", function () {
  var imgHover = $(this).find('img').data('hover');
  $(this).find('img').attr('src', imgHover);
});
$(".segura-estoque-destaque figure").on("mouseout", function () {
  var imgOriginal = $(this).find('img').data('original');
  $(this).find('img').attr('src', imgOriginal);
});
